module.exports = __webpack_public_path__ + "static/media/sec_graph.a4659ed4.jpg";